import React from 'react'
import {Box , Typography , Grid ,  IconButton} from '@mui/material'
import CustomButton from './CustomButton'
import CloseIcon from "@mui/icons-material/Close";  
const updateModalstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 480,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: '5px'
  };


const DeleteModal = ({handleCloseModal , action , processing  ,content , title , btnTitle = "Delete Template"}) => {
  return (
    <Box sx={updateModalstyle}>
         <Box sx={{display:"flex", justifyContent:"space-between" , alignItems:"center" , marginBottom:"40px"}}>
        

      <Typography
      id="modal-Update-modules"
      sx={{
        color: "#050D2E",
        fontSize: "1.25rem",
        fontWeight: 550,
        lineHeight: "24px",
      }}
    >
      {title}
    </Typography>

    <IconButton
              onClick={handleCloseModal}
            >
              <CloseIcon />
            </IconButton>
          </Box>
   
    <Typography
      id="modal-Update-modules"
      sx={{
        color: "#50566E",
        fontSize: "1rem",
        lineHeight: "24px",
        mt: 2,
      }}
    >
   {content}
    </Typography>
    <Grid
      container
      justifyContent="flex-end"
      columnSpacing={2}
      sx={{ mt: 4 }}
    >
      <CustomButton
        text="Cancel"
        type="secondary"
        processing={false}
        action={handleCloseModal}
      />
      <div style={{ width: "20px" }}></div>
      <CustomButton
        text={btnTitle}
        type="danger"
        processing={processing}
        action={action}
      />
    </Grid>
  </Box>
  )
}

export default DeleteModal